import React from 'react';
import { EventTypes } from '../services/eventConstants';
import sendNotApprovedPageEvent from '../services/sendNotApprovedPageEvent';

const makeTranslateWithLink = (
  translate: (key: string, params?: Record<string, unknown> | undefined) => string
): ((
  key: string,
  href: string,
  params?: { [key: string]: unknown } | undefined,
  eventStreamEventName?: EventTypes
) => React.ReactNode) => {
  const translateWithLink = (
    key: string,
    href: string,
    params?: { [key: string]: unknown } | undefined,
    eventStreamEventName?: EventTypes
  ): React.ReactNode => {
    const translated = translate(key, {
      startLink: '{startLink}',
      endLink: '{endLink}',
      ...params
    });

    const [beforeLink, withinAndAfterLink] = translated.split('{startLink}', 2);
    const [withinLink, afterLink] = withinAndAfterLink?.split('{endLink}', 2) ?? [];

    return (
      <React.Fragment>
        {beforeLink}
        <a
          href={href}
          onClick={() => {
            if (eventStreamEventName != null) {
              sendNotApprovedPageEvent(eventStreamEventName);
            }
          }}
          className='not-approved-text-link'
          target='_blank'
          rel='noreferrer'>
          {withinLink}
        </a>
        {afterLink}
      </React.Fragment>
    );
  };

  return translateWithLink;
};

export default makeTranslateWithLink;
